module.exports = __webpack_public_path__ + "img/1.2ba04800.png";